import './InfoBlock.css';
import CommissionStructure from './CommissionStructure';
import PayoutTable from './PayoutTable';

const InfoBlock = () => {
  return (
    <div className="info-block" id="section-benefits">
      <CommissionStructure />
      <PayoutTable />
    </div>
  );
};

export default InfoBlock;
